<template>
  <div id="home">
      <mycarousel></mycarousel>
      <div class="homeProduct titleBox">
          <p class="title">朝睿科技产品矩阵</p>
          <p class="subtitle">全经营场景覆盖，快速高效解决经营难题</p>
          <div class="homeProductBox">
            <ul class="homeProductBoxLeft">
              <li v-for="(item,index) in productLeft" :key="index" @mouseover="changeProduct(index+1)">
                <img :src="item.icon" alt="">
                <div>
                  <p class="productTitle">{{item.title}}</p>
                  <p class="productSubtitle">{{item.subtitle}}</p>
                </div>
              </li>
            </ul>
            <div class="homeProductBoxRight">
              <ul :class="'poul'+changeProductIndex">
                <li v-for="(item,index) in productRight" :key="index">
                  <p class="productTitle">{{item.title}}</p>
                  <p class="productSubtitle">{{item.subtitle}}</p>
                  <div class="pagelist">
                    <div v-for="(list,i) in item.pagelist" :key="i">
                      <img :src="list.icon" alt="">
                      <p>{{list.title}}</p>
                    </div>
                  </div>
                  <!-- <button class="button1">免费试用</button>
                  <button class="button2">查看详情</button> -->
                </li>
              </ul>
            </div>
          </div>
      </div>
      <div class="homeService titleBox">
         <p class="title">完善的服务能力</p>
         <p class="subtitle">为商家提供全方位一站式服务，实现高效经营</p>
         <ul class="homeServiceBox">
          <li v-for="(item,index) in homeService" :key="index" @mousemove="changeServiceIndex=index">
            <!-- <div class="homeServiceBox1" v-show="changeServiceIndex==index">
              <div class="topTitle">
                <img :src="item.icon_on" alt="">
                <span>{{item.title}}</span>
              </div>
              <div class="remake">
                {{item.remake}}
              </div>
            </div> -->
            <!-- <div class="homeServiceBox2" v-show="changeServiceIndex!=index"> -->
            <div class="homeServiceBox2">
              <div class="topTitle">
                <img :src="item.icon" alt="">
                <span>{{item.title}}</span>
              </div>
              <ul>
                <li v-for="(list,i) in item.pagelist" :key="i">
                  <img src="@/assets/home/serviceIcon.png" alt="">
                  <span>{{list}}</span>
                </li>
              </ul>
            </div>
          </li>
         </ul>
      </div>

      <div class="homeGuarantee titleBox">
        <p class="title title1">我们的服务保障</p>
        <p class="subtitle subtitle1">为商家提供全方位一站式服务，实现高效经营</p>

        <ul class="homeGuaranteeList">
          <li v-for="(item,index) in homeGuaranteeList" :key="index">
            <img :src="item.icon" alt="">
            <p>{{item.title}}</p>
          </li>
        </ul>

        <p class="title">我们的合作品牌</p>
        <el-carousel>
          <el-carousel-item v-for="(item,index) in brandData" :key="index">
            <img :src="item" alt="" class="brandImg">
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="homeAbout titleBox">
        <p class="title title1">关于朝睿科技</p>
        <p class="subtitle subtitle1">为商家提供全方位一站式服务，实现高效经营</p>

        <ul>
          <li>
            <p class="aboutTitle">公司简介</p>
            <div v-html="homeAbout.content"></div>
          </li>
          <li>
            <img :src="homeAbout.icon" alt="">
          </li>
        </ul>
      </div>

      <!-- <div class="homeNews">
        <ul class="tab">
          <li :class="[changeNewsIndex==0?'on':'']" @click="changeNewsIndex=0">新闻资讯</li>
          <li :class="[changeNewsIndex==1?'on':'']" @click="changeNewsIndex=1">产品动态</li>
        </ul>
        <ul v-show="changeNewsIndex==0" class="newsUl">
          <li v-for="(item,index) in homeNews" :key="index">
            <p class="num">{{index+1}}</p>
            <div class="newsBox">
                <div class="newsTopBox">
                    <p class="title">{{item.title}}</p>
                    <p class="time">{{item.time}}</p>
                </div>
                <div class="content">{{item.content}}</div>
            </div>
          </li>
        </ul>
        <ul v-show="changeNewsIndex==1" class="newsUl">
          <li v-for="(item,index) in homeProduct" :key="index">
            <p class="num">{{index+1}}</p>
            <div class="newsBox">
                <div class="newsTopBox">
                    <p class="title">{{item.title}}</p>
                    <p class="time">{{item.time}}</p>
                </div>
                <div class="content">{{item.content}}</div>
            </div>
          </li>
        </ul>
      </div> -->
  </div>
</template>

<script>
import mycarousel from  '@/components/carousel/carousel.vue'
export default {
  components: {
    mycarousel
  },
  data(){
    return {
      changeProductIndex:0,
      changeServiceIndex:0,
      changeNewsIndex:0,
      carouselData:[require('@/assets/home/carousel1.png'),require('@/assets/home/carousel2.png'),require('@/assets/home/carousel3.png')],
      productLeft:[
        {
          icon:require('@/assets/home/productIcon1.png'),
          title:"网站建设",
          subtitle:"六项官网定制，快速定制效果丰富"
        },
        {
          icon:require('@/assets/home/productIcon2.png'),
          title:"小程序开发",
          subtitle:"小程序定制，制作您的专属小程序"
        },
        {
          icon:require('@/assets/home/productIcon3.png'),
          title:"APP开发",
          subtitle:"IOS、安卓APP开发，随心定制"
        },
        {
          icon:require('@/assets/home/productIcon4.png'),
          title:"优质代运营",
          subtitle:"客户营销专家帮您随心所欲运营"
        },
      ],
      productRight:[
        {
          title:"网站搭建-官网定制",
          subtitle:"朝睿智慧零售解决方案，通过门店数字化、渠道数字化、导购数字化、营销数字化、会员数字化等帮助企业搭建数字化基建，实现全时全域经营，驱动可持续智慧增长。",
          pagelist:[
            {
              icon:require('@/assets/home/pagelist1.png'),
              title:"企业官网定制",
            },
            {
              icon:require('@/assets/home/pagelist2.png'),
              title:"品牌官网定制",
            },
            {
              icon:require('@/assets/home/pagelist3.png'),
              title:"电商官网定制",
            },
            {
              icon:require('@/assets/home/pagelist4.png'),
              title:"响应式网站定制",
            },
            {
              icon:require('@/assets/home/pagelist5.png'),
              title:"营销网站定制",
            },
            {
              icon:require('@/assets/home/pagelist6.png'),
              title:"外贸网站定制",
            },
          ]
        },
        {
          title:"小程序开发-功能定制",
          subtitle:"智慧商超，深度融合朝睿智慧零售和海鼎零售云能力，打通线上线下全渠道经营场景，提升商超零售商全链路数字化运营能力，一站式管理全渠道销售业务。",
          pagelist:[
            {
              icon:require('@/assets/home/pagelist7.png'),
              title:"企业小程序",
            },
            {
              icon:require('@/assets/home/pagelist8.png'),
              title:"餐饮小程序",
            },
            {
              icon:require('@/assets/home/pagelist9.png'),
              title:"商城小程序",
            },
            {
              icon:require('@/assets/home/pagelist10.png'),
              title:"酒店小程序",
            },
            {
              icon:require('@/assets/home/pagelist11.png'),
              title:"社交小程序",
            },
            {
              icon:require('@/assets/home/pagelist12.png'),
              title:"其他小程序定制",
            },
          ]
        },
        {
          title:"APP开发-个性定制",
          subtitle:"为中国商家打造的全链路数字化出海解决方案，帮助商家“从0到1”打通海外媒体、进行渠道精准引流，提供管家式运营服务及策略支持，通过构建跨境电商服务新生态。",
          pagelist:[
            {
              icon:require('@/assets/home/pagelist13.png'),
              title:"IOS开发",
            },
            {
              icon:require('@/assets/home/pagelist14.png'),
              title:"安卓开发",
            },
            {
              icon:require('@/assets/home/pagelist15.png'),
              title:"混合应用开发",
            },
            {
              icon:require('@/assets/home/pagelist16.png'),
              title:"H5开发",
            }
          ]
        },
        {
          title:"代运营-品牌运营",
          subtitle:"朝睿智慧酒店解决方案，是酒店综合解决方案。集成客房管理、房间状态管理、线上预约、线上购物、会员管理和营销活动等丰富功能，助力酒店通过线上渠道获取客户、实现精准直销。",
          pagelist:[
            {
              icon:require('@/assets/home/pagelist17.png'),
              title:"微信代运营",
            },
            {
              icon:require('@/assets/home/pagelist18.png'),
              title:"网站推广",
            },
            {
              icon:require('@/assets/home/pagelist19.png'),
              title:"新媒体运营",
            },
            {
              icon:require('@/assets/home/pagelist20.png'),
              title:"海外运营",
            },
            {
              icon:require('@/assets/home/pagelist21.png'),
              title:"数字互动运营",
            }
          ]
        }
      ],
      homeService:[
        {
          title:"广告投放",
          icon:require('@/assets/home/serviceIcon_1.png'),
          icon_on:require('@/assets/home/serviceIcon_1_on.png'),
          remake:"朝睿盟聚，以大数据、智能算法、营销自动化等技术及优质媒体源，在腾讯新闻、腾讯视频、快手、小红书、抖音和微信、QQ等社交平台，为广告主提供包括广告引流-营销互动-交易转化-持续复购等的全链路营销解决方案，助力品牌实现品效增长。",
          pagelist:['品牌策略','创意内容','电商引流','媒介合作']
        },
        {
          title:"整合营销",
          icon:require('@/assets/home/serviceIcon_2.png'),
          icon_on:require('@/assets/home/serviceIcon_2_on.png'),
          remake:"朝睿盟聚，以大数据、智能算法、营销自动化等技术及优质媒体源，在腾讯新闻、腾讯视频、快手、小红书、抖音和微信、QQ等社交平台，为广告主提供包括广告引流-营销互动-交易转化-持续复购等的全链路营销解决方案，助力品牌实现品效增长。",
          pagelist:['品牌策略','创意内容','电商引流','媒介合作']
        },
        {
          title:"私域运营",
          icon:require('@/assets/home/serviceIcon_3.png'),
          icon_on:require('@/assets/home/serviceIcon_3_on.png'),
          remake:"朝睿盟聚，以大数据、智能算法、营销自动化等技术及优质媒体源，在腾讯新闻、腾讯视频、快手、小红书、抖音和微信、QQ等社交平台，为广告主提供包括广告引流-营销互动-交易转化-持续复购等的全链路营销解决方案，助力品牌实现品效增长。",
          pagelist:['商城运营','企微运营','内容运营','终端带教']
        },
        {
          title:"个性开发",
          icon:require('@/assets/home/serviceIcon_4.png'),
          icon_on:require('@/assets/home/serviceIcon_4_on.png'),
          remake:"朝睿盟聚，以大数据、智能算法、营销自动化等技术及优质媒体源，在腾讯新闻、腾讯视频、快手、小红书、抖音和微信、QQ等社交平台，为广告主提供包括广告引流-营销互动-交易转化-持续复购等的全链路营销解决方案，助力品牌实现品效增长。",
          pagelist:['网站开发','APP开发','小程序开发','优质代运营']
        },
        {
          title:"全面服务",
          icon:require('@/assets/home/serviceIcon_5.png'),
          icon_on:require('@/assets/home/serviceIcon_5_on.png'),
          remake:"朝睿盟聚，以大数据、智能算法、营销自动化等技术及优质媒体源，在腾讯新闻、腾讯视频、快手、小红书、抖音和微信、QQ等社交平台，为广告主提供包括广告引流-营销互动-交易转化-持续复购等的全链路营销解决方案，助力品牌实现品效增长。",
          pagelist:['品牌服务','创意定制','电商服务','媒介服务']
        },
      ],
      homeGuaranteeList:[
        {
          icon:require('@/assets/home/guaranteeIcon1.png'),
          title:"7x24小时五星售后服务"
        },
        {
          icon:require('@/assets/home/guaranteeIcon2.png'),
          title:"10年沉淀系统稳定"
        },
        {
          icon:require('@/assets/home/guaranteeIcon3.png'),
          title:"上市企业质量保证"
        },
        {
          icon:require('@/assets/home/guaranteeIcon4.png'),
          title:"多重认真安全可靠"
        },
        {
          icon:require('@/assets/home/guaranteeIcon5.png'),
          title:"专利技术品效更佳"
        }
      ],
      brandData:[require('@/assets/home/carousel4.png'),require('@/assets/home/carousel4.png'),require('@/assets/home/carousel4.png')],
      homeAbout:{
        content:"广州市朝睿信息科技有限公司是一家位于广州的科技公司。我们致力于为客户提供创新的数字解决方案。公司成立于2005年，迄今为止已成为行业内的领先者。<br/><br/>朝睿信息科技有限公司拥有一支专业的团队，他们具备丰富的技术经验和创造力。我们的团队成员擅长开发高质量的软件、网站和移动应用程序，以满足客户的各种需求。我们注重与客户的沟通，并且根据客户的要求量身定制解决方案。<br/><br/>我们的产品和服务涵盖了多个领域，包括商业软件开发、数据分析、云计算、人工智能等。我们秉承着以客户为中心的理念，不断提升我们的技术能力，为客户提供最优质的解决方案。",
        icon:require('@/assets/home/about.png')
      },
      homeNews:[
        {
          title:"朝睿科技连续三年助力网络安全宣传周",
          content:"作为中小企业数字化经营的赋能者，朝睿始终将网络安全放在企业经营中的中药位置。",
          time:"2022-09-12"
        },
        {
          title:"网页设计公司怎么设计网站？",
          content:"网站的设计是个复杂的过程，一般做网站的都是从零开始做的，前期是对整个制作流程进行合理规划。例如做网站首先需要了解用户喜欢什么……",
          time:"2022-09-12"
        },
        {
          title:"高端网站定制怎么设计？一般定制的流程…",
          content:"网站的资料—定要包含企业相关的所有信息，比如网站名称、网站域名、注册时间、域名、网站地址、企业文化等方面因素。",
          time:"2022-09-12"
        },
        {
          title:"知识付费哪个平台好做？该怎么做？",
          content:"知识付费是一个热门的概念，就是在一定时间内(例如一天、一个小时、一天)消费者购买一定数量的'知识'。",
          time:"2022-09-12"
        }
      ],
      homeProduct:[
        {
          title:"朝睿科技连续三年助力网络安全宣传周",
          content:"作为中小企业数字化经营的赋能者，朝睿始终将网络安全放在企业经营中的中药位置。",
          time:"2022-09-12"
        },
        {
          title:"网页设计公司怎么设计网站？",
          content:"网站的设计是个复杂的过程，一般做网站的都是从零开始做的，前期是对整个制作流程进行合理规划。例如做网站首先需要了解用户喜欢什么……",
          time:"2022-09-12"
        },
        {
          title:"高端网站定制怎么设计？一般定制的流程…",
          content:"网站的资料—定要包含企业相关的所有信息，比如网站名称、网站域名、注册时间、域名、网站地址、企业文化等方面因素。",
          time:"2022-09-12"
        },
        {
          title:"知识付费哪个平台好做？该怎么做？",
          content:"知识付费是一个热门的概念，就是在一定时间内(例如一天、一个小时、一天)消费者购买一定数量的'知识'。",
          time:"2022-09-12"
        }
      ]
    }
  },
  methods:{
    changeProduct(e){
      this.changeProductIndex = e
    }
  }
}
</script>

<style lang="scss">
  :root {
    --web-max-width: auto;
    --web-min-width: 1300px;
  }
  #home{
    .titleBox{
      .title{
        padding-top: 46px;
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 8px;
      }
      .subtitle{
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
      }
    }

    .homeProduct{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      height: 700px;
      background-image: url('../../assets/home/productBg.png');
      background-size: auto 100%; 
      .homeProductBox{
        width: 1200px;
        margin:46px auto;
        display: flex;
        justify-content: space-between;
        .homeProductBoxLeft{
          margin-right: 30px;
          li{
            display: flex;
            width: 364px;
            background-color: #fff;
            box-shadow: 1px 1px 10px 1px rgba(0,0,0,0.04);
            padding: 20px;
            border-radius: 4px 4px 4px 4px;
            cursor: pointer;
            img{
              width: 50px;
              margin-right: 20px;
            }
            .productTitle{
              font-size: 18px;
              font-weight: bold;
              color: #333333;
              margin-bottom: 8px;
            }
            .productSubtitle{
              font-size: 14px;
              font-weight: 400;
              color: #666666;
            }
          }
          li:hover{
            transform: translateY(-10px);
            transition: all 0.5s;
          }
          li:nth-child(-n+3){
            margin-bottom: 30px;
          }
        }
        .homeProductBoxRight{
          background-image: url('../../assets/home/productBg2.png');
          background-size: 100% 100%; 
          width: 806px;
          height: 458px;
          overflow: hidden;
          color: #fff;
          .poul1{
            transform: translateY(0px);
            transition: all 1s;
          }
          .poul2{
            transform: translateY(-458px);
            transition: all 1s;
          }
          .poul3{
            transform: translateY(-916px);
            transition: all 1s;
          }
          .poul4{
            transform: translateY(-1364px);
            transition: all 1s;
          }
          li{
            width: 806px;
            height: 458px;
            padding: 53px 60px;
          }
          .productTitle{
            font-size: 28px;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 12px;
          }
          .productSubtitle{
            font-size: 16px;
            font-weight: 400;
            color: #FFFFFF;
            margin-bottom: 64px;
          }
          img{
            width: 42px;
            margin-bottom: 12px;
          }
          .pagelist{
            display: flex;
            text-align: center;
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
            margin-bottom: 72px;
            div{
                margin-right: 32px;
            }
          }
          .button1{
            width: 118px;
            height: 40px;
            background: #0071EF;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #0071EF;
            color: #fff;
            margin-right: 36px;
          }
          .button2{
            width: 118px;
            height: 40px;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #FFFFFF;
            color: #fff;
            background-color: transparent;
          }
        }
      }
    }

    .homeService{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      height: 600px;
      background-image: url('../../assets/home/serviceBg.png');
      background-size: auto 100%; 
      .homeServiceBox{
        width: 1200px;
        display: flex;
        margin:46px auto;
        .topTitle{
          display: flex;
          align-items: center;
          img{
            width: 26px;
            margin-right: 12px;
          }
        }
        .homeServiceBox1{
          background: #FFFFFF;
          height: 340px;
          .topTitle{
            width: 300px;
            height: 100px;
            background-image: url('../../assets/home/serviceBg2.png');
            background-size: cover;
            padding-left: 26px;
            color: #fff;
          }
          .remake{
            padding: 24px;
            font-size: 14px;
            font-weight: 400;
            color: #999999;
            line-height: 1.8;
          }
        }
        .homeServiceBox2{
          // width: 224px;
          width: 240px;
          height: 340px;
          background: #FFFFFF;
          padding: 48px 30px;
          cursor: pointer;
          .topTitle{
            padding-bottom: 24px;
            border-bottom: 1px solid #EBEDEF;
            margin-bottom: 24px;
          }
          ul{
            li{
              margin-bottom: 26px;
              font-size: 14px;
              font-weight: 400;
              color: #999999;
            }
            img{
              width: 16px;
              margin-right: 8px;
            }
          }
        }
      }
    }

    .homeGuarantee{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      height: 840px;
      background-image: url('../../assets/home/guaranteeBg.png');
      background-size: cover;
      background-repeat: no-repeat; 
      .title1,.subtitle1{
        color: #fff;
      }
      .homeGuaranteeList{
        display: flex;
        margin:0 auto;
        width: 1200px;
        justify-content: space-between;
        margin-top: 48px;
        li{
          background-color: #fff;
          width: 204px;
          height: 253px;
          box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
          border-radius: 8px 8px 8px 8px;
          text-align: center;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          cursor: pointer;
        }
        li:hover{
          transform: translateY(-10px);
          transition: all 0.5s;
        }
        img{
          width: 204px;
        }
      }

      .el-carousel__container{
        width: 1200px;
        height: 137px;
        margin:50px auto 0;
      }
      .brandImg{
        height: 100%;
        // width: auto;
      }
    }

    .homeAbout{
      min-width:var(--web-min-width);
      // max-width:var(--web-max-width);
      margin:0 auto;
      height: 693px;
      background-image: url('../../assets/home/homeAboutBg.png');
      background-size: cover;
      background-repeat: no-repeat; 
      ul{
        display: flex;
        margin:46px auto 0;
        width: 1200px;
        // height: 448px;
        background: #FFFFFF;
        box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
        border-radius: 12px 12px 12px 12px;
        opacity: 1;
        padding: 34px 56px;
        .aboutTitle{
          font-size: 38px;
          font-weight: 500;
          color: #333333;
          margin-bottom: 24px;
        }
        div{
          font-size: 18px;
          font-weight: 400;
          color: #666666;
          line-height: 1.8;
        }
        img{
          width: 380px;
          margin-left: 78px;
        }
      }
    }

    .homeNews{
      .tab{
        display: flex;
        justify-content: center;
        li{
          width: 120px;
          height: 44px;
          font-size: 30px;
          font-weight: 400;
          color: #333333;
          margin:0 37px;
          cursor: pointer;
        }
        .on{
          color: #0071EF;
          position: relative;
        }
        .on::after{
          content:"";
          display: block;
          width: 100%;
          height: 2px;
          background: #0071EF;
          position: absolute;
          bottom: -10px;
          border-radius: 10px;
        }
      }

      .newsUl{
        display: flex;
        flex-wrap: wrap;
        width: 1200px;
        margin:46px auto 124px;
        li{
          width: 580px;
          height: 146px;
          background: #FFFFFF;
          box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
          border-radius: 8px 8px 8px 8px;
          padding: 32px;
          display: flex;
          .num{
            width: 30px;
            height: 30px;
            background: #0071EF;
            box-shadow: 0px 2px 18px 1px rgba(217,223,231,0.6);
            border-radius: 4px 4px 4px 4px;
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 10px;
          }
          .newsBox{
            .newsTopBox{
              display: flex;
              align-items: flex-end;
              margin-bottom: 18px;
              .title{
                width: 356px;
                font-size: 18px;
                font-weight: 400;
                color: #333333;
                overflow:hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow:ellipsis;
                margin-right: 48px;
              }
              .time{
                font-size: 12px;
                font-weight: 400;
                color: #666666;
              }
            }
            .content{
              width: 466px;
              height: 40px;
              font-size: 14px;
              font-weight: 400;
              color: #666666;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
        li:nth-child(2n-1){
          margin-right: 40px;
        }
        li:nth-child(-n+2){
          margin-bottom: 40px;
        }
        li:hover{
          cursor: pointer;
          box-shadow: 0px 2px 26px 1px rgba(217,223,231,0.8);
        }
      }
    }
  }
</style>